/**
 * Adds up the pending and total tasks of every actionable task type.
 *
 * Non-actionable types are excluded: they are reported by the progress
 * endpoint but the store cannot work on them, so counting them would inflate
 * every header that summarizes the workload.
 *
 * @param {object} progress - Progress keyed by task type, as returned by /progress/task_type.
 * @returns {{total: number, pending: number}} Summed counts across actionable task types.
 */
export function countActionableProgress(progress) {
  return Object.values(progress ?? {})
    .filter(entry => entry?.actionable)
    .reduce(
      (acc, entry) => ({
        total: acc.total + entry.total,
        pending: acc.pending + entry.pending,
      }),
      { total: 0, pending: 0 },
    );
}
